<template>
  <div
    @click="$router.push({ name: to })"
    class="w-full bg-white shadow-2l p-5 rounded-lg hover:bg-gray-100 cursor-pointer"
  >
    <h3 class="font-bold text-xl mb-3">{{ title }}</h3>
    <p class="text-sm text-gray-600">
      {{ description }}
    </p>
    <button
      class="w-full block mt-2 p-2 text-md font-bold bg-indigo-100 text-indigo-700 rounded-lg focus:outline-none focus:bg-indigo-200"
    >
      Configurar
    </button>
  </div>
</template>

<script>
export default {
  name: 'setting-card',
  props: {
    title: String,
    to: String,
    description: String
  }
}
</script>

<style></style>
